<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'App',
  created() {
    if (window.localStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(window.localStorage.getItem('store'))
        )
      )
      // 刷新重置loading状态
      // this.$store.state.permission.loading = false
    }
	window.addEventListener('beforeunload', () => {
		window.localStorage.setItem('store', JSON.stringify(this.$store.state))
	})
  }
}
</script>

<style media="print">
@page {
  size: auto;
  margin: 0mm;
}
</style>
